import { render } from "./DialogFilterDate.vue?vue&type=template&id=3aa1d5b9"
import script from "./DialogFilterDate.vue?vue&type=script&lang=js"
export * from "./DialogFilterDate.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__